// @ts-ignore
import {DateTime} from 'luxon';
import {FieldResult} from "../../model/api/field-result";
import {CrystalclearBackUrl} from "./crystalclear-back-url";
import {Customer} from "../../model/customer/customer";
import {AccountDefinition} from "../../model/customer/account-definition";
import {Contract} from "../../model/exchange/contract";
import {BankAccount} from "../../model/customer/bank-account";
import {Trader} from "../../model/customer/trader";
import {TradingEnvironment} from "../../model/exchange/trading-environment";
import {Source} from "../../model/mapping/source";
import {Fee} from "../../model/mapping/fee";
import {AccountTrader} from "../../model/customer/account-trader";
import {BrokerageTable} from "../../model/customer/brokerage-table";
import {Broker} from "../../model/customer/broker";
import {ExecTrader} from "../../model/customer/exec-trader";
import {MoneyOwner} from "../../model/customer/money-owner";
import {ReportTemplate} from "../../model/archive/report-template";
import {ReportProfile} from "../../model/archive/report-profile";

export class CrystalclearCommonBackUrl {
  static readonly GET_COMMON_FIELD_COUNTRIES: CrystalclearBackUrl.UrlConf<FieldResult<any>> = {
    url: '/api/common/field/countries',
    type: FieldResult
  };
  static readonly GET_COMMON_FIELD_TIMEZONES: CrystalclearBackUrl.UrlConf<FieldResult<any>> = {
    url: '/api/common/field/timeZones',
    type: FieldResult
  };
  static readonly GET_COMMON_FIELD_CURRENCIES: CrystalclearBackUrl.UrlConf<FieldResult<string>> = {
    url: '/api/common/field/currencies',
    type: FieldResult
  };
  static readonly GET_COMMON_FIELD_LANGUAGES: CrystalclearBackUrl.UrlConf<FieldResult<any>> = {
    url: '/api/common/field/languages',
    type: FieldResult
  };
  static readonly GET_COMMON_FIELD_VATRATES: CrystalclearBackUrl.UrlConf<FieldResult<any>> = {
    url: '/api/common/customer/field/vatRates',
    type: FieldResult
  };
  static readonly GET_COMMON_FIELD_OWNERS: CrystalclearBackUrl.UrlConf<FieldResult<any>> = {
    url: '/api/common/customer/field/owners',
    type: FieldResult
  };
  static readonly GET_COMMON_FIELD_BROKERS: CrystalclearBackUrl.UrlConf<FieldResult<Broker>> = {
    url: '/api/common/customer/field/brokers',
    type: FieldResult
  };
  static readonly GET_COMMON_FIELD_EXEC_TRADERS: CrystalclearBackUrl.UrlConf<FieldResult<ExecTrader>> = {
    url: '/api/common/customer/field/execTraders',
    type: FieldResult
  };
  static readonly GET_COMMON_FIELD_CUSTOMERS: CrystalclearBackUrl.UrlConf<FieldResult<Customer>> = {
    url: '/api/common/customer/field/customers',
    type: FieldResult
  };
  static readonly GET_COMMON_FIELD_ACCOUNTS: CrystalclearBackUrl.UrlConf<FieldResult<AccountDefinition>> = {
    url: '/api/common/customer/field/accounts',
    type: FieldResult
  };
  static readonly GET_COMMON_FIELD_ACCOUNT_TRADERS: CrystalclearBackUrl.UrlConf<FieldResult<AccountTrader>> = {
    url: '/api/common/customer/field/accountTraders',
    type: FieldResult
  };
  static readonly GET_COMMON_FIELD_CONTRACTS: CrystalclearBackUrl.UrlConf<FieldResult<Contract>> = {
    url: '/api/common/exchange/field/contracts',
    type: FieldResult
  };
  static readonly GET_COMMON_FIELD_CLEARINGHOUSES: CrystalclearBackUrl.UrlConf<FieldResult<any>> = {
    url: '/api/common/exchange/field/clearingHouses',
    type: FieldResult
  };
  static readonly GET_COMMON_FIELD_EXCHANGECODES: CrystalclearBackUrl.UrlConf<FieldResult<any>> = {
    url: '/api/common/exchange/field/exchangeCodes',
    type: FieldResult
  };
  static readonly GET_COMMON_FIELD_ACCOUNTTYPES: CrystalclearBackUrl.UrlConf<FieldResult<any>> = {
    url: '/api/common/exchange/field/accountTypes',
    type: FieldResult
  };
  static readonly GET_COMMON_FIELD_TRADING_ENVIRONMENTS: CrystalclearBackUrl.UrlConf<FieldResult<TradingEnvironment>> = {
    url: '/api/common/exchange/field/tradingEnvironments',
    type: FieldResult
  };
  static readonly GET_COMMON_FIELD_BANK_ACCOUNT: CrystalclearBackUrl.UrlConf<FieldResult<BankAccount>> = {
    url: '/api/common/customer/field/bankAccounts',
    type: FieldResult
  };
  static readonly GET_COMMON_FIELD_MONEY_OWNER: CrystalclearBackUrl.UrlConf<FieldResult<MoneyOwner>> = {
    url: '/api/common/customer/field/moneyOwners',
    type: FieldResult
  };
  static readonly GET_COMMON_FIELD_BROKERAGE_TABLE: CrystalclearBackUrl.UrlConf<FieldResult<BrokerageTable>> = {
    url: '/api/common/customer/field/brokeragetables',
    type: FieldResult
  };
  static readonly GET_COMMON_FIELD_TRADER: CrystalclearBackUrl.UrlConf<FieldResult<Trader>> = {
    url: '/api/common/mapping/field/traders',
    type: FieldResult
  };
  static readonly GET_COMMON_FIELD_SOURCE: CrystalclearBackUrl.UrlConf<FieldResult<Source>> = {
    url: '/api/common/mapping/field/sources',
    type: FieldResult
  };
  static readonly GET_COMMON_FIELD_FEE: CrystalclearBackUrl.UrlConf<FieldResult<Fee>> = {
    url: '/api/common/mapping/field/fees',
    type: FieldResult
  };
  static readonly GET_COMMON_FIELD_SECURITY_USER: CrystalclearBackUrl.UrlConf<FieldResult<any>> = {
    url: '/api/common/security/field/security-users',
    type: FieldResult
  };
  static readonly GET_COMMON_FIELD_CLEARING_USER: CrystalclearBackUrl.UrlConf<FieldResult<any>> = {
    url: '/api/common/security/field/clearing-users',
    type: FieldResult
  };
  static readonly GET_COMMON_FIELD_AUTHORITIES: CrystalclearBackUrl.UrlConf<FieldResult<any>> = {
    url: '/api/common/security/field/authorities',
    type: FieldResult
  };
  static readonly GET_COMMON_FIELD_USER_GROUP: CrystalclearBackUrl.UrlConf<FieldResult<any>> = {
    url: '/api/common/security/field/user-groups',
    type: FieldResult
  };
  static readonly GET_COMMON_FIELD_BILLING_INVOICES: CrystalclearBackUrl.UrlConf<FieldResult<ReportProfile>> = {
    url: '/api/common/billing/field/invoices',
    type: FieldResult
  };
}

